export const formatNumber = (value: number) => new Intl.NumberFormat().format(value)
export const formatNumberReversed = (value: string) => parseInt(value.replace(/,/g,""))